import { render } from "./MarketingCampaignAnalyticsPanel.vue?vue&type=template&id=1b1ead0f&scoped=true"
import script from "./MarketingCampaignAnalyticsPanel.vue?vue&type=script&lang=js"
export * from "./MarketingCampaignAnalyticsPanel.vue?vue&type=script&lang=js"

import "./MarketingCampaignAnalyticsPanel.vue?vue&type=style&index=0&id=1b1ead0f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1ead0f"]])

export default __exports__